/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react'
import { Input, Form } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './CustomUrlInput.module.scss'
import { registryREurl, urlREStr, youtubeUrlStr } from 'src/core/helpers'

interface CustomUrlInputProps {
  name: string,
  required?: boolean,
  placeholder: string,
  isYoutubeUrl?: boolean
  isRegistryUrl?: boolean
  onChange?: (value: string) => void
}

const CustomUrlInput: React.FC<CustomUrlInputProps> = (props) => {
  const { t } = useTranslation()
  const {
    name,
    required = false,
    placeholder,
    isYoutubeUrl = false,
    onChange = null,
    isRegistryUrl = null
  } = props

  const field = {
    YOU_TUBE: {
      expresion: youtubeUrlStr,
      label: t('Projects.NoValidUrl')
    },
    REGISTRY: {
      expresion: registryREurl,
      label: t('Projects.NoValidYouTubeUrl')
    },
    OTHER: {
      expresion: urlREStr,
      label: t('Projects.NoValidYouTubeUrl')
    }
  }[isYoutubeUrl ? 'YOU_TUBE' : isRegistryUrl ? 'REGISTRY' : 'OTHER']


  const handleChange = (value: string) => {
    if (onChange) { onChange(value) }
  }

  return (
    <Form.Item
      name={name}
      rules={[
        { required, message: t('general.RequiredValidation'), whitespace: true },
        { pattern: field.expresion, message: field.label }
      ]}
    >
      <Input
        className={styles['custom-input']}
        placeholder={placeholder}
        size='large'
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e.target.value)}
      />
    </Form.Item>
  )
}

export default CustomUrlInput
